// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"b476e76b","272":"b476e76b","651":"b476e76b","702":"b476e76b"}[chunkId] + ".css";
};